import React from 'react';

export default class Page10 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">

                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport  tablesrink paraspace1">
                                                <tbody>
                                                <tr>
                                                    <th width="10%" align="left" valign="top"
                                                        className="green_curve supLinesapce">Learning Style
                                                        Combination
                                                    </th>

                                                    <th width="40%" align="left" valign="top"
                                                        className=" green_curve1">Summary
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <td width="10%" align="left" valign="top"
                                                        className="lightgreen  ">
                                                        <div className="innerTablePadding1"><p>Explorer</p>
                                                        </div>
                                                    </td>

                                                    <td width="40%" align="left" valign="top"
                                                        className="lightgreen  "><p>Curious and willing to learn
                                                        but needs to involve others in the process and tell
                                                        them ‘all about it’ – may side-track or dominate group
                                                        learning.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="10%" align="left" valign="top"
                                                        className="darkgreen  ">
                                                        <div className="innerTablePadding3"><p>Volunteer</p>
                                                        </div>
                                                    </td>

                                                    <td width="40%" align="left" valign="top"
                                                        className="darkgreen  "><p>Will assist others to learn
                                                        and share experiences. Concern for others is helpful
                                                        but may at times hinder own learning.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="10%" align="left" valign="top"
                                                        className="lightgreen  ">
                                                        <div className="innerTablePadding1"><p>Yo-Yo</p></div>
                                                    </td>

                                                    <td width="40%" align="left" valign="top"
                                                        className="lightgreen  "><p>Changeable approach to
                                                        learning. Enthusiastic one minute, uninterested the
                                                        next! Very dependent on personal interest in subject
                                                        matter and mood.</p>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <div
                                                className="lightgreencontentbg keyquestionpad uiheading greennumberroundbg1">
                                                <p>The following section outlines the next steps for you to
                                                    consider now that you have
                                                    identified your preferred learning styles.</p>
                                            </div>
                                            <div className="circle_title"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>NEXT STEPS
                                            </div>
                                            <p>You should now have an understanding of the variety of learning
                                                methods preferred by different
                                                personalities and you should also have identified your own. So
                                                what next? Here are a few
                                                suggestions for maintaining momentum (although they are by no
                                                means exhaustive):</p>
                                            <div className="border_subtitle">Test yourself</div>
                                            <p>You may have an opportunity to do this formally – but why not
                                                find an area of interest to test your
                                                learning style. You could try different approaches to find out
                                                which are most effective.</p>
                                            <div className="border_subtitle">Look for opportunities to practise
                                                different learning styles
                                            </div>
                                            <div className="paraspace"><p>You may have identified learning
                                                styles you’ve never used or even considered before. Try them
                                                anyway; you may find them surprisingly effective. Opportunities
                                                might include:</p></div>
                                            <ul className="greenbullet-list sept">
                                                <li>Formal courses</li>
                                                <li>Structured activities</li>
                                                <li>On-the-job activities</li>
                                                <li>Off-the-job activities</li>
                                                <li>Open learning</li>
                                                <li>Books, reading</li>
                                                <li className="list-bottom-pad">Videos/DVDs.</li>
                                            </ul>


                                            <div className="border_subtitle">Write a development plan</div>
                                            <p>Information about learning styles can be used to make your own
                                                and your team’s development
                                                plans more appropriate and therefore more effective.</p>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page9')}
                                                     className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page11')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}